export default __webpack_public_path__ + "static/media/EducationHatBlack.9780cf5a.svg";